import {
  LocationScope,
  MergedLocationVar,
  LocationVarInheritance,
  LocationVarKey,
} from '@swivl-mono/types';

import { WorksheetComponentLabel } from '../Label/WorksheetComponent.Label';
import { useAutosave } from 'react-autosave';
import React, { useEffect } from 'react';
import '../WorksheetComponent/WorksheetComponent.scss';
import { SelectableOption, Dropdown } from '@swivl-mono/ui';

interface Props {
  className: string;
  label?: string;
  variable: MergedLocationVar
  options?: SelectableOption[]
  type: LocationScope;
  controlType: "input" | "textarea"
  isEditing: boolean;

  disableReverting?: boolean;
  saveVariable: (value: string) => void;
  customize(): void;
  deleteVariable(): void;
  isLoading: boolean;
}

export function WorksheetComponentDropdown(props: Props) {
  const {
    label,
    type,
    variable,
    isEditing,
    disableReverting,
    saveVariable,
    deleteVariable,
  } = props;

  const [value, setValue] = React.useState<string>(variable.value);

  useEffect(() => {
    setValue(value);
  }, [value]);
  useAutosave({
    data: value,
    onSave: (v) => {

      if (v !== variable.value) {

        saveVariable(v);
      }
    },
  });

  const textForOption = props.options?.find((o) => o.value === value)?.label || "Unset"


  return (
    <div
      className={`WorksheetComponent WorksheetComponentDropdown ${props.className} ${isEditing ? 'isEditing' : ''
        } inheritance_${variable.inheritance}
        control_${props.controlType}
      `}
    >
      <WorksheetComponentLabel
        key={variable.inheritance + variable.key + variable.id}
        text={label}
        inheritance={variable.inheritance}
        isEditing={isEditing}
        type={type}
        canRevert={!disableReverting}
        isLoading={props.isLoading}
        deleteVariable={deleteVariable}
      />
      {isEditing ? (
        variable.inheritance === LocationVarInheritance.NONE ?
          <Dropdown options={props.options}
            isLoading={props.isLoading}
            showSearch={true}
            value={value}
            onSet={(v) => setValue(v)}
          /> : (
            <div className="parentText" onClick={props.customize}>
              {textForOption}
              <div className="parentTextOverlay">Click to Customize</div>
            </div>
          )
      ) : (
        <div className="valueText">{textForOption}</div>
      )}
    </div>
  );
}
